import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Headphones, BookOpen, Smartphone } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-20 pb-8 px-4 bg-[#0A0A0A] text-center" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-116">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black bg-[#8FF650] text-black leading-snug mb-5 inline-block px-3 py-2 rounded-sm" style={{
          textShadow: '0 0 10px rgba(143, 246, 80, 0.8), 0 0 20px rgba(143, 246, 80, 0.6), 0 0 40px rgba(143, 246, 80, 0.4), 0 0 80px rgba(143, 246, 80, 0.2)',
          boxShadow: '0 0 15px rgba(143, 246, 80, 0.5), 0 0 30px rgba(143, 246, 80, 0.3), inset 0 0 15px rgba(143, 246, 80, 0.1)'
        }} data-id="element-117">
            TRANSFORMA TUS TIEMPOS MUERTOS EN CRECIMIENTO
          </h1>

          <p className="text-base md:text-lg font-bold text-gray-400 mb-4 max-w-3xl mx-auto" data-id="element-118">
            DESCARGA Y ESCUCHA TODOS LOS DIAS A LOS MEJORES MENTORES DEL MUNDO
            MIENTRAS ENTRENAS, MANEJAS O EN CUALQUIER MOMENTO DISPONIBLE.
            ENCONTRA MAS DISCIPLINA, ENFOQUE Y MENTALIDAD QUE TE AYUDE A TOMAR
            MEJORES DECISIONES Y AVANZAR MAS RAPIDO EN TU VIDA
          </p>

          <p className="text-lg md:text-xl font-bold text-gray-300 mb-6 max-w-3xl mx-auto" data-id="element-119">
            Todo el conocimiento que necesitás para mejorar tu mentalidad,
            hábitos y forma de pensar.
          </p>

          {/* Product Mockup Image */}
          <div className="mb-6 relative max-w-2xl mx-auto" data-id="element-120">
            <div className="absolute inset-0 bg-[#8FF650] opacity-10 blur-3xl rounded-full" data-id="element-121"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mbSppSfgnknUJoDtAZMShf/LOGO_(13).jpg" alt="MegaPack - 2000 Audiolibros y 1500 Ebooks de Desarrollo Personal y Crecimiento" className="relative z-10 w-full rounded-2xl shadow-2xl border-2 border-gray-800" data-id="element-122" />
          </div>

          <p className="text-base md:text-lg font-medium text-gray-400 mb-6 max-w-2xl mx-auto" data-id="element-123">
            Miles de ideas poderosas listas para escuchar o leer en cualquier
            momento del día.
          </p>

          <div className="flex flex-col items-center justify-center gap-3" data-id="element-124">
            <CTAButton text="QUIERO LOS 2000 AUDIOLIBROS AHORA ⚡" data-id="element-125" />

            <div className="flex items-center gap-2 text-[#8FF650] font-bold mt-2" data-id="element-126">
              <ShieldCheck className="w-5 h-5" data-id="element-127" />
              <span className="text-sm md:text-base" data-id="element-128">
                ✅ Garantía de satisfacción de 7 días
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}